import React from "react";

/** Simply Served mark — a served document with a GPS pin and a speed check. Transparent SVG. */
export function SimplyServedLogo({ className = "", withWordmark = true, light = true }) {
  const ink = light ? "#ffffff" : "#0b1f3a";
  const muted = light ? "rgba(255,255,255,.72)" : "#475569";
  return (
    <svg viewBox="0 0 620 150" className={className} role="img" aria-label="Simply Served" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="ss-blue" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#4aa3ff" /><stop offset="1" stopColor="#1f5fa8" /></linearGradient>
        <linearGradient id="ss-gold" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#f3c66b" /><stop offset="1" stopColor="#d99a2b" /></linearGradient>
      </defs>
      <g transform="translate(10 10)">
        {/* document */}
        <path d="M30 6 H88 L116 34 V118 a10 10 0 0 1 -10 10 H30 a10 10 0 0 1 -10 -10 V16 a10 10 0 0 1 10 -10 Z" fill="url(#ss-blue)" />
        <path d="M88 6 V34 H116 Z" fill="#0b1f3a" fillOpacity=".35" />
        <path d="M38 54 H98 M38 70 H98 M38 86 H80" stroke="#ffffff" strokeOpacity=".85" strokeWidth="5" strokeLinecap="round" />
        {/* GPS pin */}
        <path d="M108 60 c-16 0 -27 12 -27 27 c0 20 27 45 27 45 s27 -25 27 -45 c0 -15 -11 -27 -27 -27 Z" fill="url(#ss-gold)" stroke={light ? "#0b1f3a" : "#ffffff"} strokeWidth="4" />
        <circle cx="108" cy="86" r="9" fill="#0b1f3a" />
        {/* served check */}
        <circle cx="26" cy="112" r="20" fill="#0b1f3a" stroke="#4aa3ff" strokeWidth="4" />
        <path d="M16 112 l7 7 l14 -15" stroke="#ffffff" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      </g>
      {withWordmark && (
        <g>
          <text x="170" y="82" fontFamily="'Plus Jakarta Sans', 'IBM Plex Sans', system-ui, sans-serif" fontWeight="800" fontSize="64" letterSpacing="-2.5" textLength="420" lengthAdjust="spacingAndGlyphs" fill={ink}>Simply <tspan fill="#4aa3ff">Served</tspan></text>
          <text x="174" y="116" fontFamily="'IBM Plex Mono', ui-monospace, monospace" fontWeight="600" fontSize="14" letterSpacing="4" textLength="416" lengthAdjust="spacingAndGlyphs" fill={muted}>PROCESS SERVICE COMMAND</text>
        </g>
      )}
    </svg>
  );
}
